import { render, staticRenderFns } from "./EditTenantCustomerAccount.vue?vue&type=template&id=2c856c06&scoped=true&"
import script from "./EditTenantCustomerAccount.vue?vue&type=script&lang=js&"
export * from "./EditTenantCustomerAccount.vue?vue&type=script&lang=js&"
import style0 from "./EditTenantCustomerAccount.vue?vue&type=style&index=0&id=2c856c06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c856c06",
  null
  
)

export default component.exports